// Viewer 3D Scene API

// 3D transform
function Sculpteo3DViewerTransform3D(array) {
  if (typeof array == "string") {
    array = eval("([" + array + "])");
  }

  if (typeof array != "undefined" && typeof array.length != "undefined") {
    if (typeof array[0].length != "undefined") {
      array = $M(array).ensure4x4();
    } else if (array.length == 16) {
      array = Matrix.unflatten4x4(array).transpose();
    } else if (array.length == 9) {
      array = Matrix.unflatten3x3(array).ensure4x4().transpose();
    }
  }

  var matrix = array || Matrix.I(4);

  this.matrix = matrix;
}

Sculpteo3DViewerTransform3D.prototype.toString = function () {
  return this.matrix.transpose().flatten().toString();
};

Sculpteo3DViewerTransform3D.prototype.translate = function (x, y, z) {
  var M = Matrix.Translation($V([x, y, z])).ensure4x4();

  return new Sculpteo3DViewerTransform3D(M.x(this.matrix));
};

Sculpteo3DViewerTransform3D.prototype.scale = function (x, y, z) {
  var M = Matrix.Diagonal([x, y, z, 1]).ensure4x4();

  return new Sculpteo3DViewerTransform3D(M.x(this.matrix));
};

Sculpteo3DViewerTransform3D.prototype.rotate = function (arad, x, y, z) {
  var M = Matrix.Rotation(arad, $V([x, y, z])).ensure4x4();

  return new Sculpteo3DViewerTransform3D(M.x(this.matrix));
};

Sculpteo3DViewerTransform3D.prototype.rotateQ = function (w, x, y, z) {
  var intM = Sculpteo3DViewerTransform3D.quatMat3(w, x, y, z);
  var M = Matrix.unflatten4x4([
    intM[0],
    intM[1],
    intM[2],
    0.0,
    intM[3],
    intM[4],
    intM[5],
    0.0,
    intM[6],
    intM[7],
    intM[8],
    0.0,
    0,
    0,
    0,
    1.0,
  ]).transpose();

  return new Sculpteo3DViewerTransform3D(M.x(this.matrix));
};

Sculpteo3DViewerTransform3D.prototype.inverse = function () {
  return new Sculpteo3DViewerTransform3D(this.matrix._inverse4x4());
};

Sculpteo3DViewerTransform3D.prototype.transpose = function () {
  return new Sculpteo3DViewerTransform3D(this.matrix.transpose());
};

Sculpteo3DViewerTransform3D.prototype.x = function (t) {
  if (t.length == 4) {
    return this.matrix.x($V(t)).flatten();
  }

  return new Sculpteo3DViewerTransform3D(this.matrix.x(t.matrix));
};

Sculpteo3DViewerTransform3D.prototype.decompose = function () {
  var flat = this.matrix.flatten();
  var tr = flat.slice(12, 15);

  var srcMatrix = flat
    .slice(0, 3)
    .concat(flat.slice(4, 7))
    .concat(flat.slice(8, 11));

  var scale = Sculpteo3DViewerTransform3D.normalize(srcMatrix);
  var rot = Sculpteo3DViewerTransform3D.diagonalize(srcMatrix);

  return { tr: tr, scale: scale, rot: rot };
};

Sculpteo3DViewerTransform3D.identity = new Sculpteo3DViewerTransform3D();

Sculpteo3DViewerTransform3D.translation = function (x, y, z) {
  return new Sculpteo3DViewerTransform3D().translate(x, y, z);
};

Sculpteo3DViewerTransform3D.scale = function (x, y, z) {
  return new Sculpteo3DViewerTransform3D().scale(x, y, z);
};

Sculpteo3DViewerTransform3D.rotation = function (arad, x, y, z) {
  return new Sculpteo3DViewerTransform3D().rotate(arad, x, y, z);
};

// Interpolate between srcTransform (v=0) and dstTransform (v=1), returns new transform
// see http://stackoverflow.com/questions/3093455/3d-geometry-how-to-interpolate-a-matrix
Sculpteo3DViewerTransform3D.quatMat3 = function (qw, qx, qy, qz) {
  var n = qx * qx + qy * qy + qz * qz + qw * qw;
  var s;

  if (n > 0.0) {
    s = 2.0 / n;
  } else {
    s = 0.0;
  }

  var xs = qx * s;
  var ys = qy * s;
  var zs = qz * s;
  var wx = qw * xs;
  var wy = qw * ys;
  var wz = qw * zs;
  var xx = qx * xs;
  var xy = qx * ys;
  var xz = qx * zs;
  var yy = qy * ys;
  var yz = qy * zs;
  var zz = qz * zs;

  return [
    1.0 - (yy + zz),
    xy - wz,
    xz + wy,
    xy + wz,
    1.0 - (xx + zz),
    yz - wx,
    xz - wy,
    yz + wx,
    1.0 - (xx + yy),
  ];
};

Sculpteo3DViewerTransform3D.quatNormalize = function (arot) {
  var norm = Math.sqrt(
    arot[3] * arot[3] +
      arot[0] * arot[0] +
      arot[1] * arot[1] +
      arot[2] * arot[2]
  );

  if (norm) {
    norm = 1.0 / norm;

    return [arot[0] * norm, arot[1] * norm, arot[2] * norm, arot[3] * norm];
  } else {
    return arot;
  }
};

Sculpteo3DViewerTransform3D.quatSlerp = function (arot, brot, t) {
  // Arot and v1 should be unit length or else
  // something broken will happen.
  // Compute the cosine of the angle between the two vectors.
  var dot =
    arot[0] * brot[0] +
    arot[1] * brot[1] +
    arot[2] * brot[2] +
    arot[3] * brot[3];

  if (dot > 0.9995) {
    // If the inputs are too close for comfort, linearly interpolate
    // and normalize the result.
    result = [
      arot[0] + t * (brot[0] - arot[0]),
      arot[1] + t * (brot[1] - arot[1]),
      arot[2] + t * (brot[2] - arot[2]),
      arot[3] + t * (brot[3] - arot[3]),
    ];

    return Sculpteo3DViewerTransform3D.quatNormalize(result);
  }

  if (dot < -1) {
    dot = -1;
  }

  if (dot > 1) {
    dot = 1;
  }

  var theta_0 = Math.acos(dot); // Theta_0 = angle between input vectors
  var theta = theta_0 * t; // Theta = angle between arot and result

  v2 = [
    brot[0] - dot * arot[0],
    brot[1] - dot * arot[1],
    brot[2] - dot * arot[2],
    brot[3] - dot * arot[3],
  ];
  v2 = Sculpteo3DViewerTransform3D.quatNormalize(v2); // { arot, v2 } is now an orthonormal basis

  return [
    arot[0] * Math.cos(theta) + v2[0] * Math.sin(theta),
    arot[1] * Math.cos(theta) + v2[1] * Math.sin(theta),
    arot[2] * Math.cos(theta) + v2[2] * Math.sin(theta),
    arot[3] * Math.cos(theta) + v2[3] * Math.sin(theta),
  ];
};

Sculpteo3DViewerTransform3D.matMul = function (A, B) {
  return [
    A[0] * B[0] + A[1] * B[3] + A[2] * B[6],
    A[0] * B[1] + A[1] * B[4] + A[2] * B[7],
    A[0] * B[2] + A[1] * B[5] + A[2] * B[8],

    A[3] * B[0] + A[4] * B[3] + A[5] * B[6],
    A[3] * B[1] + A[4] * B[4] + A[5] * B[7],
    A[3] * B[2] + A[4] * B[5] + A[5] * B[8],

    A[6] * B[0] + A[7] * B[3] + A[8] * B[6],
    A[6] * B[1] + A[7] * B[4] + A[8] * B[7],
    A[6] * B[2] + A[7] * B[5] + A[8] * B[8],
  ];
};

Sculpteo3DViewerTransform3D.matTranspose = function (A, B) {
  return [A[0], A[3], A[6], A[1], A[4], A[7], A[2], A[5], A[8]];
};

// Assumes uniform scale
Sculpteo3DViewerTransform3D.normalize = function (A) {
  var m00 = A[0];
  var m01 = A[1];
  var m02 = A[2];
  var m10 = A[3];
  var m11 = A[4];
  var m12 = A[5];
  var m20 = A[6];
  var m21 = A[7];
  var m22 = A[8];
  var det =
    m00 * (m11 * m22 - m21 * m12) -
    m10 * (m01 * m22 - m21 * m02) +
    m20 * (m01 * m12 - m11 * m02);
  var absq2 = Math.pow(Math.abs(det), -1.0 / 3.0);

  A[0] *= absq2;
  A[1] *= absq2;
  A[2] *= absq2;
  A[3] *= absq2;
  A[4] *= absq2;
  A[5] *= absq2;
  A[6] *= absq2;
  A[7] *= absq2;
  A[8] *= absq2;

  return 1.0 / absq2;
};

// Assumes pure rotation
Sculpteo3DViewerTransform3D.diagonalize = function (A) {
  var m00 = A[0];
  var m01 = A[1];
  var m02 = A[2];
  var m10 = A[3];
  var m11 = A[4];
  var m12 = A[5];
  var m20 = A[6];
  var m21 = A[7];
  var m22 = A[8];
  var tr = m00 + m11 + m22; // Trace
  var S, qw, qx, qy, qz;

  if (tr > 0.0) {
    S = Math.sqrt(1.0 + tr);
    qw = 0.5 * S;
    S = 0.5 / S;
    qx = (m21 - m12) * S;
    qy = (m02 - m20) * S;
    qz = (m10 - m01) * S;
  } else if (m00 > m11 && m00 > m22) {
    S = Math.sqrt(1.0 + m00 - m11 - m22);
    qx = 0.5 * S;
    S = 0.5 / S;
    qw = (m21 - m12) * S;
    qy = (m01 + m10) * S;
    qz = (m02 + m20) * S;
  } else if (m11 > m22) {
    S = Math.sqrt(1.0 + m11 - m00 - m22);
    qy = 0.5 * S;
    S = 0.5 / S;
    qw = (m02 - m20) * S;
    qx = (m01 + m10) * S;
    qz = (m12 + m21) * S;
  } else {
    S = Math.sqrt(1.0 + m22 - m00 - m11);
    qz = 0.5 * S;
    S = 0.5 / S;
    qw = (m10 - m01) * S;
    qx = (m02 + m20) * S;
    qy = (m12 + m21) * S;
  }

  return [qx, qy, qz, qw];
};

Sculpteo3DViewerTransform3D.interpolate = function (
  srcTransform,
  dstTransform,
  v
) {
  var flatA = srcTransform.matrix.flatten();
  var flatB = dstTransform.matrix.flatten();

  // Extract translations
  var srcTranslation = flatA.slice(12, 15);
  var dstTranslation = flatB.slice(12, 15);

  // Extract 3x3 matrixes
  var srcMatrix = flatA
    .slice(0, 3)
    .concat(flatA.slice(4, 7))
    .concat(flatA.slice(8, 11));
  var dstMatrix = flatB
    .slice(0, 3)
    .concat(flatB.slice(4, 7))
    .concat(flatB.slice(8, 11));

  // Decompose into rotation and non-uniform scale
  var srcScale = Sculpteo3DViewerTransform3D.normalize(srcMatrix);
  var srcQ = Sculpteo3DViewerTransform3D.diagonalize(srcMatrix);

  var dstScale = Sculpteo3DViewerTransform3D.normalize(dstMatrix);
  var dstQ = Sculpteo3DViewerTransform3D.diagonalize(dstMatrix);

  // Spherical interpolation of rotations
  var intQ = Sculpteo3DViewerTransform3D.quatSlerp(srcQ, dstQ, v);

  // Linear interpolation of scale and translation
  var intScale = (1 - v) * srcScale + v * dstScale;
  var intTranslation = [
    (1 - v) * srcTranslation[0] + v * dstTranslation[0],
    (1 - v) * srcTranslation[1] + v * dstTranslation[1],
    (1 - v) * srcTranslation[2] + v * dstTranslation[2],
  ];

  // Recompose the transform
  var intM = Sculpteo3DViewerTransform3D.quatMat3(
    intQ[3],
    intQ[0],
    intQ[1],
    intQ[2]
  );
  var intM4 = [
    intM[0] * intScale,
    intM[1] * intScale,
    intM[2] * intScale,
    intTranslation[0],
    intM[3] * intScale,
    intM[4] * intScale,
    intM[5] * intScale,
    intTranslation[1],
    intM[6] * intScale,
    intM[7] * intScale,
    intM[8] * intScale,
    intTranslation[2],
    0,
    0,
    0,
    1,
  ];

  return new Sculpteo3DViewerTransform3D(intM4);
};

Sculpteo3DViewerTransform3D.crossProduct = function (u, v) {
  return [
    u[1] * v[2] - u[2] * v[1],
    u[2] * v[0] - u[0] * v[2],
    u[0] * v[1] - u[1] * v[0],
  ];
};

Sculpteo3DViewerTransform3D.dotProduct = function (u, v) {
  return u[0] * v[0] + u[1] * v[1] + u[2] * v[2];
};

Sculpteo3DViewerTransform3D.normalizeVector = function (u) {
  var sz = Math.sqrt(Sculpteo3DViewerTransform3D.dotProduct(u, u));

  return [u[0] / sz, u[1] / sz, u[2] / sz];
};

// 3D Scene node
function Sculpteo3DViewerSceneNode(
  viewer,
  instance,
  id,
  transform,
  material,
  flags
) {
  this.viewer = viewer;
  this.id = id;
  this.transform = transform || Sculpteo3DViewerTransform3D.identity;
  this.material = material || "global";
  this.operation = "union";
  this.opacity = 1.0;
  this.drawMode = Sculpteo3DViewerSceneNode.DRAWMODE_FLAT;
  this.bboxColor = { r: 0, g: 0, b: 0, a: 64 };
  this.wireframeColor = { r: 0, g: 0, b: 0, a: 255 };
  this.interactive = 0;
  this.childNodes = [];
  this.instance = instance;
  this.listeners = {};
  this.flags = flags;
  this.bbox = null;
  this.size = null;
  this.center = null;

  // A unique key to keep track of created nodes
  var key = "";

  for (var i = 0; i < 32; i++) {
    key += ((Math.random() * 16) | 0).toString(16);
  }

  this.key = key;

  var data = viewer.$jself.data("viewer");

  if (!data) {
    data = {};
    viewer.$jself.data("viewer", data);
  }

  if (!data["nodes"]) {
    data["nodes"] = {};
  }

  data["nodes"][key] = this;

  if (this.instance) {
    this.viewer._mapNodeEvent(this.instance, this);
  }

  this.addEventListener("bbox", function (minx, miny, minz, maxx, maxy, maxz) {
    for (var i = 0; i < arguments.length; ++i) {
      arguments[i] = parseFloat(arguments[i]);
    }
    this.bbox = {
      min: [minx, miny, minz],
      max: [maxx, maxy, maxz],
    };
    this.center = {
      x: (minx + maxx) / 2.0,
      y: (miny + maxy) / 2.0,
      z: (minz + maxz) / 2.0,
    };
    this.size = {
      x: maxx - minx,
      y: maxy - miny,
      z: maxz - minz,
    };
  });
}

Sculpteo3DViewerSceneNode.INTERACTIVE_CLICK = 1 << 0;
Sculpteo3DViewerSceneNode.INTERACTIVE_MOUSEENTER = 1 << 1;
Sculpteo3DViewerSceneNode.INTERACTIVE_MOUSELEAVE = 1 << 2;
Sculpteo3DViewerSceneNode.INTERACTIVE_MOUSEDOWN = 1 << 3;
Sculpteo3DViewerSceneNode.INTERACTIVE_MOUSEUP = 1 << 4;
Sculpteo3DViewerSceneNode.INTERACTIVE_MOUSEMOVE = 1 << 5;

Sculpteo3DViewerSceneNode.INTERACTIVE_SELECT = 1 << 16;
Sculpteo3DViewerSceneNode.INTERACTIVE_ROTATE = 1 << 17;
Sculpteo3DViewerSceneNode.INTERACTIVE_PAN = 1 << 18;
Sculpteo3DViewerSceneNode.INTERACTIVE_SCALE = 1 << 19;
Sculpteo3DViewerSceneNode.INTERACTIVE_MASK = 0xff << 16;

Sculpteo3DViewerSceneNode.INTERACTIVE_LOAD = 1 << 24;
Sculpteo3DViewerSceneNode.INTERACTIVE_PROGRESS = 1 << 25;
Sculpteo3DViewerSceneNode.INTERACTIVE_BBOX = 1 << 26;
Sculpteo3DViewerSceneNode.INTERACTIVE_ERRORMSG = 1 << 27;
Sculpteo3DViewerSceneNode.INTERACTIVE_WARNING = 1 << 28;
Sculpteo3DViewerSceneNode.INTERACTIVE_GROUPS = 1 << 29;
Sculpteo3DViewerSceneNode.INTERACTIVE_LOADING_ERROR = 1 << 30;

Sculpteo3DViewerSceneNode.DRAWMODE_FLAT = 1 << 0;
Sculpteo3DViewerSceneNode.DRAWMODE_WIREFRAME = 1 << 1;
Sculpteo3DViewerSceneNode.DRAWMODE_BBOX = 1 << 2;
Sculpteo3DViewerSceneNode.DRAWMODE_NO_CUT = 1 << 3;
Sculpteo3DViewerSceneNode.DRAWMODE_ON_TOP = 1 << 4;

Sculpteo3DViewerSceneNode.prototype.appendChild = function (child, op) {
  if (!op) {
    op = "union";
  }

  child.detach();
  child.parentNode = this;
  child.operation = op;
  this.childNodes.push(child);

  if (this.instance && child.instance) {
    this.viewer._attachNode(this.instance, child.instance, child.operation);
  }
};

Sculpteo3DViewerSceneNode.prototype.getParent = function () {
  return this.parentNode;
};

Sculpteo3DViewerSceneNode.prototype.detach = function () {
  if (!this.parentNode) {
    return;
  }

  if (this.instance) {
    this.viewer._detachNode(this.instance);
  }

  // Remove from parent children list
  var newList = [];
  var oldList = this.parentNode.childNodes;

  for (var k = 0; k < oldList.length; k++) {
    if (oldList[k] != this) {
      newList.push(oldList[k]);
    }
  }

  this.parentNode.childNodes = newList;

  delete this.parentNode;
};

Sculpteo3DViewerSceneNode.prototype.destruct = function (free) {
  // Stop any worker on node
  if (typeof this.worker != "undefined") {
    this.worker.terminate();
  }

  this.detach();
  this.destructChildren(free);

  if (free) {
    if (this.instance) {
      var data = this.viewer.$jself.data("viewer");
      delete data["nodes"][this.key];
      this.viewer._deleteNode(this.instance_view);
    }
  }
};

Sculpteo3DViewerSceneNode.prototype.destructChildren = function (free) {
  while (this.childNodes.length > 0) {
    var child = this.childNodes[0];

    this.childNodes.splice(0, 1);
    child.destruct(free);
  }

  this.childNodes = [];
};

/* Style */

Sculpteo3DViewerSceneNode.prototype.setMaterial = function (
  material,
  envmap,
  smooth,
  bumpnoise,
  gauss
) {
  this.material = material || "global";
  this.envmap = envmap;
  this.smooth = smooth;
  this.bumpnoise = bumpnoise;
  this.gaussian_amplitude = gauss;

  if (this.instance) {
    this.viewer._setNodeMaterial(
      this.instance,
      this.material,
      this.envmap,
      this.smooth,
      this.bumpnoise,
      this.gaussian_amplitude
    );
  }
};

Sculpteo3DViewerSceneNode.prototype.setSolidity = function (
  min_solidity,
  max_solidity
) {
  this.solidity = [min_solidity, max_solidity];

  if (this.instance) {
    this.viewer._setNodeSolidity(this.instance, min_solidity, max_solidity);
  }
};

Sculpteo3DViewerSceneNode.prototype.setFlags = function (flags) {
  this.flags = flags;

  if (this.instance) {
    this.viewer._setNodeFlags(this.instance, flags);
  }
};

Sculpteo3DViewerSceneNode.prototype.setGroup = function (group) {
  if (typeof group != "undefined") {
    this.group = group;
  } else {
    delete this.group;
  }

  if (this.instance) {
    this.viewer._setNodeGroup(this.instance, group);
  }
};

Sculpteo3DViewerSceneNode.prototype.setOpacity = function (opacity) {
  this.opacity = opacity;

  if (this.instance) {
    this.viewer._setNodeOpacity(this.instance, opacity);
  }
};

Sculpteo3DViewerSceneNode.prototype.setTransform = function (transform) {
  this.transform = transform;

  if (this.instance) {
    this.viewer._setNodeTransform(this.instance, transform.toString());
  }
};

Sculpteo3DViewerSceneNode.prototype.getWorldTransform = function () {
  var transform = new Sculpteo3DViewerTransform3D(this.transform.matrix);
  var parent = this.parentNode;

  while (parent) {
    transform = parent.transform.x(transform);
    parent = parent.parentNode;
  }

  return transform;
};

Sculpteo3DViewerSceneNode.prototype.setDrawMode = function (mask) {
  this.drawMode = mask;

  if (this.instance) {
    this.viewer._setNodeDrawMode(this.instance, mask);
  }
};

Sculpteo3DViewerSceneNode.prototype.setBboxColor = function (r, g, b, a) {
  this.bboxColor = { r: r, g: g, b: b, a: a };

  if (this.instance) {
    this.viewer._setNodeBboxColor(this.instance, r, g, b, a);
  }
};

Sculpteo3DViewerSceneNode.prototype.setWireframeColor = function (r, g, b, a) {
  this.wireframeColor = { r: r, g: g, b: b, a: a };

  if (this.instance) {
    this.viewer._setNodeWireframeColor(this.instance, r, g, b, a);
  }
};

Sculpteo3DViewerSceneNode.prototype.setStyle = function (style) {
  if (style.material && this.material != style.material) {
    this.setMaterial(style.material);
  }

  if (style.transform && this.transform != style.transform) {
    this.setTransform(style.transform);
  }

  if (style.flags && this.flags != style.flags) {
    this.setFlags(style.flags);
  }

  if (style.drawMode && this.drawMode != style.drawMode) {
    this.setDrawMode(style.drawMode);
  }

  if (style.bboxColor && this.bboxColor != style.bboxColor) {
    this.setBboxColor(
      style.bboxColor.r,
      style.bboxColor.g,
      style.bboxColor.b,
      style.bboxColor.a
    );
  }

  if (style.wireframeColor && this.wireframeColor != style.wireframeColor) {
    this.setWireframeColor(
      style.wireframeColor.r,
      style.wireframeColor.g,
      style.wireframeColor.b,
      style.wireframeColor.a
    );
  }
};

Sculpteo3DViewerSceneNode.prototype.animate = function (
  style,
  duration,
  easing,
  done
) {
  // Reuse easing functions from jQuery
  if (!easing) {
    easing = "swing";
  }

  if (typeof easing != "function") {
    easing = $.easing[easing];
  }

  var time1 = +new Date();
  var srcStyle = $.extend(true, {}, this); // Deep copy of current style
  var dstStyle = $.extend(false, {}, srcStyle); // Shallow copy and overwrite

  $.extend(dstStyle, style);

  var that = this;
  var animation = new Sculpteo3DViewerUIAnimation();

  var srcQ, dstQ;
  var srcScale, dstScale;
  var srcTranslation, dstTranslation;

  if (dstStyle.transform && srcStyle.transform != dstStyle.transform) {
    var flatA = srcStyle.transform.matrix.flatten();
    var flatB = dstStyle.transform.matrix.flatten();

    // Extract translations
    srcTranslation = flatA.slice(12, 15);
    dstTranslation = flatB.slice(12, 15);

    // Extract 3x3 matrixes
    srcMatrix = flatA
      .slice(0, 3)
      .concat(flatA.slice(4, 7))
      .concat(flatA.slice(8, 11));
    dstMatrix = flatB
      .slice(0, 3)
      .concat(flatB.slice(4, 7))
      .concat(flatB.slice(8, 11));

    // Decompose into rotation and non-uniform scale
    var srcScale = Sculpteo3DViewerTransform3D.normalize(srcMatrix);
    var srcQ = Sculpteo3DViewerTransform3D.diagonalize(srcMatrix);

    var dstScale = Sculpteo3DViewerTransform3D.normalize(dstMatrix);
    var dstQ = Sculpteo3DViewerTransform3D.diagonalize(dstMatrix);
  }

  var anim = function () {
    var time2 = +new Date();
    var percent = (time2 - time1) / duration;

    if (percent > 1.0) {
      percent = 1.0;
    }

    var v = easing(percent, duration * percent, 0, 1, duration);

    if (dstStyle.material && srcStyle.material != dstStyle.material) {
      that._interpolateMaterial(srcStyle.material, dstStyle.material, v);
    }

    if (dstStyle.transform && srcStyle.transform != dstStyle.transform) {
      // If the dot product is negative, the quaternions
      // have opposite handed-ness and slerp won't take
      // the shorter path. Fix by reversing one quaternion.
      var dot =
        srcQ[0] * dstQ[0] +
        srcQ[1] * dstQ[1] +
        srcQ[2] * dstQ[2] +
        srcQ[3] * dstQ[3];
      if (dot < 0) {
        dstQ[0] = -dstQ[0];
        dstQ[1] = -dstQ[1];
        dstQ[2] = -dstQ[2];
        dstQ[3] = -dstQ[3];
      }

      // Spherical interpolation of rotations
      var intQ = Sculpteo3DViewerTransform3D.quatSlerp(srcQ, dstQ, v);

      // Linear interpolation of scale and translation
      var intScale = (1 - v) * srcScale + v * dstScale;
      var intTranslation = [
        (1 - v) * srcTranslation[0] + v * dstTranslation[0],
        (1 - v) * srcTranslation[1] + v * dstTranslation[1],
        (1 - v) * srcTranslation[2] + v * dstTranslation[2],
      ];

      // Recompose the transform
      var intM = Sculpteo3DViewerTransform3D.quatMat3(
        intQ[3],
        intQ[0],
        intQ[1],
        intQ[2]
      );
      var intM4 = [
        intM[0] * intScale,
        intM[3] * intScale,
        intM[6] * intScale,
        intTranslation[0],
        intM[1] * intScale,
        intM[4] * intScale,
        intM[7] * intScale,
        intTranslation[1],
        intM[2] * intScale,
        intM[5] * intScale,
        intM[8] * intScale,
        intTranslation[2],
        0,
        0,
        0,
        1,
      ];

      that.setTransform(new Sculpteo3DViewerTransform3D(intM4));
    }

    if (dstStyle.bboxColor && srcStyle.bboxColor != dstStyle.bboxColor) {
      that.setBboxColor(
        (1.0 - v) * srcStyle.bboxColor.r + v * dstStyle.bboxColor.r,
        (1.0 - v) * srcStyle.bboxColor.g + v * dstStyle.bboxColor.g,
        (1.0 - v) * srcStyle.bboxColor.b + v * dstStyle.bboxColor.b,
        (1.0 - v) * srcStyle.bboxColor.a + v * dstStyle.bboxColor.a
      );
    }

    if (
      dstStyle.wireframeColor &&
      srcStyle.wireframeColor != dstStyle.wireframeColor
    ) {
      that.setWireframeColor(
        (1.0 - v) * srcStyle.wireframeColor.r + v * dstStyle.wireframeColor.r,
        (1.0 - v) * srcStyle.wireframeColor.g + v * dstStyle.wireframeColor.g,
        (1.0 - v) * srcStyle.wireframeColor.b + v * dstStyle.wireframeColor.b,
        (1.0 - v) * srcStyle.wireframeColor.a + v * dstStyle.wireframeColor.a
      );
    }

    if (percent < 1.0) {
      animation.timeout = setTimeout(anim, 16);
    } else if (typeof done == "function") {
      done.call(this);
    }
  };

  animation.timeout = setTimeout(anim);

  return animation;
};

Sculpteo3DViewerSceneNode.prototype.animateTransform = function (
  t,
  duration,
  easing,
  done
) {
  return this.animate({ transform: t }, duration, easing, done);
};

Sculpteo3DViewerSceneNode.prototype.exec = function (script, context) {
  return this.viewer.exec(script, context, this);
};

/* Eventing */

Sculpteo3DViewerSceneNode.prototype.setInteractive = function (enable) {
  this.interactive =
    (this.interactive & ~Sculpteo3DViewerSceneNode.INTERACTIVE_MASK) | enable;

  if (this.instance) {
    this.viewer._setNodeInteractive(this.instance, enable);
  }
};

Sculpteo3DViewerSceneNode.prototype.addEventListener = function (
  eventname,
  callback
) {
  if (!this.listeners[eventname] || this.listeners[eventname].length == 0) {
    this.listeners[eventname] = [];

    switch (eventname) {
      case "click":
        this.interactive |= Sculpteo3DViewerSceneNode.INTERACTIVE_CLICK;
        break;
      case "mouseenter":
        this.interactive |= Sculpteo3DViewerSceneNode.INTERACTIVE_MOUSEENTER;
        break;
      case "mouseleave":
        this.interactive |= Sculpteo3DViewerSceneNode.INTERACTIVE_MOUSELEAVE;
        break;
      case "mousedown":
        this.interactive |= Sculpteo3DViewerSceneNode.INTERACTIVE_MOUSEDOWN;
        break;
      case "mouseup":
        this.interactive |= Sculpteo3DViewerSceneNode.INTERACTIVE_MOUSEUP;
        break;
      case "mousemove":
        this.interactive |= Sculpteo3DViewerSceneNode.INTERACTIVE_MOUSEMOVE;
        break;
      case "load":
        this.interactive |= Sculpteo3DViewerSceneNode.INTERACTIVE_LOAD;
        break;
      case "progress":
        this.interactive |= Sculpteo3DViewerSceneNode.INTERACTIVE_PROGRESS;
        break;
      case "bbox":
        this.interactive |= Sculpteo3DViewerSceneNode.INTERACTIVE_BBOX;
        break;
      case "groups":
        this.interactive |= Sculpteo3DViewerSceneNode.INTERACTIVE_GROUPS;
        break;
      case "errorMessage":
        this.interactive |= Sculpteo3DViewerSceneNode.INTERACTIVE_ERRORMSG;
        break;
      case "warnings":
        this.interactive |= Sculpteo3DViewerSceneNode.INTERACTIVE_WARNING;
        break;
      case "loadingError":
        this.interactive |= Sculpteo3DViewerSceneNode.INTERACTIVE_LOADING_ERROR;
        break;
    }

    if (this.instance) {
      this.viewer._setNodeInteractive(this.instance, this.interactive);
    }
  }

  this.listeners[eventname].push(callback);
};

Sculpteo3DViewerSceneNode.prototype.removeEventListener = function (
  eventname,
  callback
) {
  if (!this.listeners[eventname]) {
    return;
  }

  if (callback) {
    index = this.listeners[eventname].indexOf(callback);

    if (index >= 0) {
      this.listeners[eventname].splice(index, 1);
    }
  } else {
    this.listeners[eventname] = [];
  }

  if (this.listeners[eventname].length == 0) {
    switch (eventname) {
      case "click":
        this.interactive &= ~Sculpteo3DViewerSceneNode.INTERACTIVE_CLICK;
        break;
      case "mouseenter":
        this.interactive &= ~Sculpteo3DViewerSceneNode.INTERACTIVE_MOUSEENTER;
        break;
      case "mouseleave":
        this.interactive &= ~Sculpteo3DViewerSceneNode.INTERACTIVE_MOUSELEAVE;
        break;
      case "mousedown":
        this.interactive &= ~Sculpteo3DViewerSceneNode.INTERACTIVE_MOUSEDOWN;
        break;
      case "mouseup":
        this.interactive &= ~Sculpteo3DViewerSceneNode.INTERACTIVE_MOUSEUP;
        break;
      case "mousemove":
        this.interactive &= ~Sculpteo3DViewerSceneNode.INTERACTIVE_MOUSEMOVE;
        break;
      case "load":
        this.interactive &= ~Sculpteo3DViewerSceneNode.INTERACTIVE_LOAD;
        break;
      case "progress":
        this.interactive &= ~Sculpteo3DViewerSceneNode.INTERACTIVE_PROGRESS;
        break;
      case "bbox":
        this.interactive &= ~Sculpteo3DViewerSceneNode.INTERACTIVE_BBOX;
        break;
      case "errorMessage":
        this.interactive &= ~Sculpteo3DViewerSceneNode.INTERACTIVE_ERRORMSG;
        break;
      case "warnings":
        this.interactive &= ~Sculpteo3DViewerSceneNode.INTERACTIVE_WARNING;
        break;
      case "loadingError":
        this.interactive &=
          ~Sculpteo3DViewerSceneNode.INTERACTIVE_LOADING_ERROR;
        break;
    }

    if (this.instance) {
      this.viewer._setNodeInteractive(this.instance, this.interactive);
    }
  }
};

Sculpteo3DViewerSceneNode.prototype.dispatchEvent = function (
  node_event,
  node_event_args
) {
  var b = true; // Bubble up?

  if (this.listeners && this.listeners[node_event]) {
    var c = this.listeners[node_event].slice();

    for (var i = 0; i < c.length; i++) {
      var f = c[i];

      if (typeof f == "function") {
        b = f.apply(this, node_event_args) != false && b;
      }
    }
  }

  if (b && this.parentNode) {
    this.parentNode.dispatchEvent(node_event, node_event_args);
  }
};

Sculpteo3DViewerSceneNode.prototype.click = function (callback) {
  this.addEventListener("click", callback);
};

Sculpteo3DViewerSceneNode.prototype.clone = function () {
  var clone = this.viewer.createNode(this.id);

  clone.setTransform(this.transform);

  for (var c = 0; c < this.childNodes.length; c++) {
    var child_clone = this.childNodes[c].clone();

    clone.appendChild(child_clone, this.childNodes[c].operation);
  }

  return clone;
};

Sculpteo3DViewerSceneNode.prototype.load = function (url) {
  var dfd = $.Deferred();
  var that = this;
  var f = function () {
    dfd.resolve.apply(dfd, arguments);
    that.removeEventListener("load", f);
  };

  this.addEventListener("load", f);
  this.viewer.loadModel(url, this.id);

  return dfd;
};
